import { Component, OnInit } from '@angular/core';
import { TealHealthEncounter, TealHealthEncounterDetails } from '../../../models/encounter';
import { EncounterDiaryHandler } from './encounter-diary-handler';
import { EncounterNoteHandler } from './encounter-note-handler';
import { EncounterEmailHandler } from './encounter-email-handler';
import { Store } from '@ngxs/store';
import { BlockUI, DiaryListComponent, EmailService, EncounterNotesListComponent, FaxScrollerComponent } from '@harlowe/core';
import { EncounterService } from '../../../services/encounter.service';
import { Observable } from 'rxjs';
import { TabViewModule } from 'primeng/tabview';
import { EmailManagerComponent } from '../email-manager/email-manager.component';
import { AsyncPipe, NgIf } from '@angular/common';
import { Encounters } from '../../../state/encounters/encounter-actions';
import { EncounterState } from '../../../state/encounters/encounter-state';
import { ActivatedRoute } from '@angular/router';
import { FileListComponent, EncounterFileUploader } from '../../files/file-list/file-list.component';
import { EncounterFaxHandler } from './encounter-fax-handler';
import { UtilService } from '../../../services/util.service';
import { UserInterface } from '../../../state/ui/ui-actions';
import { UserInterfaceState } from '../../../state/ui/ui-state';

@Component({
  selector: 'app-correspondence',
  standalone: true,
  imports: [TabViewModule, DiaryListComponent, EncounterNotesListComponent, EmailManagerComponent, FileListComponent, FaxScrollerComponent, NgIf, AsyncPipe],
  templateUrl: './correspondence.component.html',
  styleUrl: './correspondence.component.scss'
})
export class CorrespondenceComponent implements OnInit 
{
  showMenu$ = this._store.select(UserInterfaceState.topMenuVisibility);
  encounter: TealHealthEncounterDetails | undefined;
  activeEncounter$: Observable<TealHealthEncounterDetails | undefined> = this._store.select(EncounterState.activeEncounter);
  encounterDiaryHandler: EncounterDiaryHandler | undefined;
  encounterNoteHandler: EncounterNoteHandler | undefined;
  encounterEmailHandler: EncounterEmailHandler | undefined;
  encounterFaxHandler: EncounterFaxHandler | undefined;

  uploader?: EncounterFileUploader;

  constructor(
    private _encounters: EncounterService,
    private _util: UtilService,
    private _emails: EmailService,
    private _store: Store,
    private _route: ActivatedRoute
  ) { }

  ngOnInit() {
    this._store.dispatch(new BlockUI.BlockUI());
    this._route.paramMap.subscribe
      (
        p => {
          const eId = p.get("encounterId")
          if (eId)
            this._store.dispatch(new Encounters.EncounterSelected({ encounterId: Number.parseInt(eId) }))
        }
      );

    this.activeEncounter$.subscribe
      (
        async e => {
          if (e) {

            this.encounter = e as TealHealthEncounterDetails;
            this.uploader = new EncounterFileUploader(this.encounter?.id as number, this._encounters);
            this.encounterDiaryHandler = new EncounterDiaryHandler(this.encounter as TealHealthEncounter, this._encounters, this._store);
            this.encounterNoteHandler = new EncounterNoteHandler(this.encounter as TealHealthEncounter, this._encounters, this._store);
            this.encounterEmailHandler = await new EncounterEmailHandler(this.encounter as TealHealthEncounterDetails, this._emails, this._encounters, this._store).create(0);
            this.encounterFaxHandler = await new EncounterFaxHandler(this.encounter as TealHealthEncounterDetails, this._encounters, this._util, this._store).create();
            this._store.dispatch(new BlockUI.UnBlockUI());
          }
        }
      );
  }
}